<div #restrictedtext class="two-rows-with-ellipse"
     [container]="'body'" [placement]="tooltipPlacement"
     [disableTooltip]="restrictedtext.scrollHeight <= restrictedtext.clientHeight"
     [ngbTooltip]="text">{{ text }}</div>
